import { PropertiesTableProps } from '../../../../shared/types'

export const FormAppearanceProperties: PropertiesTableProps = {
  size: {
    doc: 'The sizes you can choose is `medium` and `large`.',
    type: 'string',
    status: 'optional',
  },
}
